import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import ReduxToastr from 'react-redux-toastr';

import store from './client/js/store/store';
import AppRoutes from "./client/js/router/AppRoutes";
import HeadParams from './client/js/component/common/HeadParams';
import { AuthProvider } from "./context/AuthContext";

const App = () => {
    return (
        <Provider store={store}>
            <AuthProvider>
                <div>
                    <HeadParams/>
                    <BrowserRouter>
                        <AppRoutes />
                    </BrowserRouter>
                    <ReduxToastr
                        timeOut={5000}
                        newestOnTop={false}
                        preventDuplicates
                        position="top-right"
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                    />
                </div>
            </AuthProvider>
        </Provider>
    )
}

export default App;
